import { useTranslation } from 'next-i18next'

import { ButtonFrames } from '~/components/ButtonFrames'
import { FramedButtonItem } from '~/components/FramedButtonItem'
import { digitalToolsItems } from '~/shared/constants/digitalTools.const'

export function DigitalTools(): React.ReactElement {
  const { t, i18n } = useTranslation(['digitalTools', 'menu'])

  return (
    <div className="min-h-screen py-8 px-4 lg:px-8  sm:px-16 ">
      <section className="max-w-3xl mx-auto">
        <ButtonFrames description={t('digitalTools:description')} title={t('menu:excelOrGeoGebra')}>
          {digitalToolsItems.map(({ icon, name, path, languages }) => {
            return (
              <FramedButtonItem
                disabledText={!languages.includes(i18n.language) ? t('digitalTools:coming') : undefined}
                icon={icon}
                key={name}
                name={t(name as 'geogebra' | 'excel')}
                path={path}
              />
            )
          })}
        </ButtonFrames>
      </section>
    </div>
  )
}
